import styled from "@emotion/styled";

export const StyledAnchor = styled.a`
  cursor: pointer;
`;
